import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/Header';
import CrisisResourceBanner from '../../components/CrisisResourceBanner';
import Icon from '../../components/AppIcon';
import OrganizationSetup from './components/OrganizationSetup';
import UserManagement from './components/UserManagement';
import UsageAnalytics from './components/UsageAnalytics';
import ComplianceDashboard from './components/ComplianceDashboard';
import HelperManagement from './components/HelperManagement';
import PlatformHealth from './components/PlatformHealth';
import AdminTabNavigation from './components/AdminTabNavigation';


const AdminConsole = () => {
  const [activeTab, setActiveTab] = useState('users');

  const tabs = [
    { id: 'analytics', label: 'Usage Analytics', icon: 'BarChart3' },
    { id: 'users', label: 'User Management', icon: 'Users' },
    { id: 'helpers', label: 'Helper Management', icon: 'UserCog' },
    { id: 'organization', label: 'Organization Setup', icon: 'Building2' },
    { id: 'compliance', label: 'Compliance', icon: 'Shield' },
    { id: 'health', label: 'Platform Health', icon: 'Activity' }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'analytics':
        return <UsageAnalytics />;
      case 'users':
        return <UserManagement />;
      case 'helpers':
        return <HelperManagement />;
      case 'organization':
        return <OrganizationSetup />;
      case 'compliance':
        return <ComplianceDashboard />;
      case 'health':
        return <PlatformHealth />;
      default:
        return <UsageAnalytics />;
    }
  };

  return (
    <>
      <Helmet>
        <title>Admin Console - Cwtch Platform</title>
        <meta name="description" content="Comprehensive platform management, user oversight, and compliance reporting for mental health support programs" />
      </Helmet>
      <CrisisResourceBanner />
      <Header />
      <div className="min-h-screen bg-background pt-32">
        <div className="max-w-7xl mx-auto px-4 py-8">
          <div className="mb-8">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                <Icon name="Settings" size={24} className="text-primary" />
              </div>
              <div>
                <h1 className="text-3xl font-bold">Admin Console</h1>
                <p className="text-muted-foreground">Manage your organization's mental health support platform</p>
              </div>
            </div>
          </div>

          <AdminTabNavigation tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />

          <div className="bg-background">
            {renderTabContent()}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminConsole;